export const baseURL = process.env.REACT_APP_BASE_URL;
export const env = process.env.REACT_APP_ENV;
export const wssURL = process.env.REACT_APP_WSS_URL;

export const mapboxAccessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
